<template>
  <v-navigation-drawer fixed app clipped
    :mini-variant.sync="navMini"
    mini-variant-width="58"
    :width="$vuetify.breakpoint.mobile ? '100%' : 350"
    mobile-breakpoint="0"
    disable-route-watcher
    v-model="navOpen">

    <v-list-item class="px-2">
      <v-btn block text @click.stop="navMini = !navMini" class="d-flex justify-end" >
        <v-icon v-if="navMini">mdi-chevron-right</v-icon>
        <v-icon v-else>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item v-for="item in items" :key="item.text" @click="navigate(item.route)" :to="{ path: item.route }">
        <v-list-item-icon>
          <v-tooltip v-if="navMini" bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">{{ item.icon }}</v-icon>
            </template>
            {{ item.text }}
          </v-tooltip>
          <v-icon v-else>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>

    <v-container v-show="displayQueueList">
      <v-overlay absolute :value="loading">
        <v-progress-circular size="80" indeterminate>
        </v-progress-circular>
      </v-overlay>
      <v-row>
        <v-col class="scroll-y queue-list">
          <v-list two-line>
            <QueueListItem v-for="(queue, idx) in queues"
                           :key="idx" :queue="queue" />
          </v-list>
        </v-col>
      </v-row>

      <v-row align="end" justify="center">
        <Pagination @loading="loading = !loading"/>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QueueListItem from './item'
import Pagination from './pagination'

export default {
  name: 'queues-list',
  data () {
    return {
      loading: false,
      navOpen: true
    }
  },
  mounted () {
    if (this.$vuetify.breakpoint.mobile || this.$route.path === '/queues/reports') {
      this.navMini = true
    } else {
      this.navMini = false
    }
  },
  components: { QueueListItem, Pagination },
  computed: {
    ...mapGetters({
      queues: 'queues',
      showAgents: 'queues/agentsPaneShow',
      getNavMini: 'queues/getNavMini',
      canReadQueueReports: 'permissions/queueReportsRead'
    }),
    navMini: {
      get: function () {
        if (this.showAgents) return true
        return this.getNavMini
      },
      set: function (val) {
        this.setNavMini(val)
      }
    },
    items () {
      return [
        { text: this.$t('queues.dashboard'), icon: 'mdi-apps', route: '/queues/dashboard' },
        ...(this.canReadQueueReports ? [{ text: this.$t('queues.reports.title'), icon: 'mdi-poll', route: '/queues/reports' }] : [])
      ]
    },
    displayQueueList () {
      return !this.navMini && (this.$route.path === '/queues/dashboard')
    }
  },
  methods: {
    ...mapActions({ setNavMini: 'queues/setNavMini' }),
    navigate (path) {
      if (this.$vuetify.breakpoint.mobile) {
        this.navMini = true
        return
      }
      if (path === '/queues/reports') {
        this.navMini = true
      } else {
        this.navMini = false
      }
    }
  }
}
</script>

<style scoped>
.v-navigation-drawer {overflow: hidden}
.v-navigation-drawer--mini-variant {cursor: pointer}
</style>
